import { Box, Button, makeStyles, TextField, Typography, useMediaQuery } from "@material-ui/core";
import { isAddress } from "ethers/lib/utils";
import ClearIcon from "@material-ui/icons/Clear";
import SearchIcon from "@material-ui/icons/Search";
import { useState } from "react";
import clsx from "clsx";

const useStyle = makeStyles((theme) => ({
  rootInput: {
    "& .MuiInputBase-root": {
      height: "2.5rem",
    },
  },
  box: {
    borderRight: `1px solid ${theme.palette.text.hint}`,
    paddingRight: "0.5rem",
    marginRight: "0.5rem",
  },
  cleanIcon: {
    cursor: "pointer",
    marginRight: "0.25rem",
  },
  hideCleanIcon: {
    visibility: "hidden",
  },
}));

export default function ButtonAddressTextField({ defaultValue, events, ...props }) {
  const cls = useStyle();
  const match = useMediaQuery((theme) => theme.breakpoints.only("xs"));
  const [value, setValue] = useState(defaultValue);
  const [helperText, setHelperText] = useState(undefined);

  function onChange(event) {
    const _value = event.target.value;
    setValue(_value);
    let error = false;
    if (!isAddress(_value)) {
      error = true;
      setHelperText("Invalid wallet address");
    } else setHelperText(undefined);
    if (events?.onChange) events.onChange(_value, error);
  }

  function onClearClick(_) {
    setValue("");
    if (events?.onClear) events.onClear();
  }

  function onConfirmClick(_) {
    if (events?.onConfirm) events.onConfirm(value);
  }

  return (
    <TextField
      {...props}
      className={cls.rootInput}
      variant="outlined"
      fullWidth
      error={Boolean(helperText)}
      helperText={helperText}
      value={value}
      onChange={onChange}
      InputProps={{
        startAdornment: match ? (
          <></>
        ) : (
          <Box className={cls.box}>
            <Typography>Address</Typography>
          </Box>
        ),
        endAdornment: (
          <Box display="flex" justifyContent="flex-end" alignItems="center">
            <ClearIcon
              fontSize="small"
              onClick={(event) => onClearClick(event)}
              className={clsx({
                [cls.cleanIcon]: value.length > 0,
                [cls.hideCleanIcon]: value.length === 0,
              })}
            />
            <Button
              disabled={Boolean(helperText) || value.length === 0}
              variant="contained"
              color="primary"
              onClick={() => onConfirmClick()}
            >
              <SearchIcon fontSize="small" />
            </Button>
          </Box>
        ),
      }}
    />
  );
}
